import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { jqxGridComponent, jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { Grid } from '../../models/grid.model';

@Component({
  selector: 'mcg-grid',
  standalone: true,
  imports: [
    jqxGridModule
  ],
  templateUrl: './grid.component.html',
  styleUrl: './grid.component.css',
})
export class GridComponent {
  @ViewChild('grid', { static: false }) public grid!: jqxGridComponent;

  private defaultGrid: Grid = {
    localization: null,
    selectionType: 'None',
    isGroupable: false,
    showToolbar: false,
    columnOpening: null,
    columnGroups: null,
    toolbar: null,
    filterType: null,
    updateFilterConditions: null,
    sortMode: 'one',
    cellHover: null,
    groupsRenderer: null,
    contextMenuEnabled: false,
    contextMenuItems: null,
    contextMenuItemClick: null,
    showGroupsHeader: true,
  }

  protected gridTheme: string = 'material';

  @Input({ required: true }) public columns = [];
  @Input({ required: true }) public data;
  @Input({ required: true }) private configuration: Grid;
  public set config(config: Grid) {
    this.configuration = { ...this.defaultGrid, ...config };
  }
  public get config(): Grid {
    return this.configuration;
  }

  @Output() public rowClick = new EventEmitter();
  @Output() public rowSelect = new EventEmitter();
  @Output() public rowUnselect = new EventEmitter();
  @Output() public rowDoubleClick = new EventEmitter();
  @Output() public gridRendered = new EventEmitter();
  @Output() public sort = new EventEmitter();
  @Output() public filter = new EventEmitter();

  public showColumn(column: string): void {
    this.grid.showcolumn(column);
  }

  public hideColumn(column: string): void {
    this.grid.hidecolumn(column);
  }

  public getColumn(column: string): object {
    return this.grid.getcolumn(column);
  }

  public setColumns(columns: any): void {
    this.grid.columns(columns);
  }

  public setColumnGroups(columns: any): any {
    this.grid.columngroups(columns);
  }

  public columnMenuOpening(column: any): void {
    this.grid.columnmenuopening(column);
  }

  public clearSelection(): void {
    this.grid.clearselection();
  }

  public getRows(): any {
    return this.grid.getrows();
  }

  public getRowData(id: number): any {
    return this.grid.getrowdata(id);
  }

  public getSelectedRowIndexes(): number[] {
    return this.grid.getselectedrowindexes();
  }

  public selectRow(id: number): void {
    this.grid.selectrow(id);
  }

  public ensureRowVisible(id: number): void {
    this.grid.ensurerowvisible(id);
  }

  public getCellAtPosition(position1: number, position2: number): any  {
    this.grid.getcellatposition(position1, position2);
  }

  public setCellValue(id: number, column: string, select: boolean): any {
    this.grid.setcellvalue(id, column, select);
  }

  public sortBy(field: string, sort: string): void {
    this.grid.sortby(field, sort);
  }

  public updateBoundData(): void {
    this.grid.updatebounddata('data');
  }

  public updateBoundCell(): void {
    this.grid.updatebounddata('cell');
  }

  public updateBoundFilter(): void {
    this.grid.updatebounddata('filter');
  }

  public updateBoundEmpty(): void {
    this.grid.updatebounddata();
  }

  public addFilter(filter: string, filterGroup: any): void {
    this.grid.addfilter(filter, filterGroup);
  }

  public removeFilter(filter: string, refresGrid: boolean): void {
    this.grid.removefilter(filter, refresGrid);
  }

  public applyFilters(): void {
    this.grid.applyfilters();
  }

  public clearFilters(): void {
    this.grid.clearfilters();
  }

  public getFilterInformation(): any {
    return this.grid.getfilterinformation();
  }

  public setSource(data: any): void {
    this.grid.source(data);
  }

  public refresh(): void {
    this.grid.refresh();
  }

  public exportData(dataType: string, fileName?: string, exportHeader?: boolean, rows?: Array<number>, exportHiddenColumns?: boolean, serverURL?: string, charSet?: string): void {
    return this.grid.exportdata(dataType, fileName, exportHeader, rows, exportHiddenColumns, serverURL, charSet)
  }

  public handleRowClick(event: unknown): void {
    this.rowClick.emit(event);
  }

  public handleRowSelect(event: unknown): void {
    this.rowSelect.emit(event);
  }

  public handleRowUnselect(event: unknown): void {
    this.rowUnselect.emit(event);
  }

  public handleRowDoubleClick(event: unknown): void {
    this.rowDoubleClick.emit(event);
  }

  protected emitGridRendered(): void {
    this.gridRendered.emit();
  }

  public handleSort(event: unknown): void {
    this.sort.emit(event);
  }

  public handleFilter(event: unknown): void {
    this.filter.emit(event);
  }
}
